var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"water-level-chart"}},[_c('div',{staticClass:"water-level-chart-title"},[_vm._v("计划资金累计完成情况")]),_vm._m(0),_c('div',{staticClass:"chart-container"},[_c('dv-water-level-pond',{attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-level-chart-details"},[_vm._v("\n    累计完成"),_c('span',[_vm._v("2716")]),_vm._v("万元\n  ")])
}]

export { render, staticRenderFns }